import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useI18n } from '../i18n/LanguageContext';

export default function NotFound() {
  const { t } = useI18n();
  return (
    <div className="container-x py-32 md:py-44 text-center" data-testid="not-found-page">
      <div className="kicker">404</div>
      <h1 className="display-1 mt-6 text-forest">Page not found.</h1>
      <p className="lead mt-8 max-w-xl mx-auto">
        Sorry, the page you’re looking for doesn’t exist or has been moved.
      </p>
      <Link to="/" className="btn-primary mt-10 inline-flex" data-testid="back-home">
        {t.nav.home} <ArrowRight size={14} />
      </Link>
    </div>
  );
}
